module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/lib/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 71);
/******/ })
/************************************************************************/
/******/ ({

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@h3/awesome-ui/dist/utils/object");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("@h3/antd-vue/lib/button");

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _h3_antd_vue_lib_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72);
/* harmony import */ var _h3_antd_vue_lib_button_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_h3_antd_vue_lib_button_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _h3_antd_vue_lib_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
/* harmony import */ var _h3_antd_vue_lib_button__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_h3_antd_vue_lib_button__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _h3_awesome_ui_src_utils_object__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
/* harmony import */ var _h3_awesome_ui_src_utils_object__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_h3_awesome_ui_src_utils_object__WEBPACK_IMPORTED_MODULE_2__);



function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


var H3Button = {
  name: 'H3Button',
  functional: true,
  inheritAttrs: false,
  props: _extends({}, _h3_antd_vue_lib_button__WEBPACK_IMPORTED_MODULE_1___default.a.props),
  render: function render(createElement, context) {
    var data = context.data,
        slots = context.slots,
        props = context.props; // remove all undefined

    Object(_h3_awesome_ui_src_utils_object__WEBPACK_IMPORTED_MODULE_2__["clearUndefined"])(props);
    data.staticClass = data.staticClass ? data.staticClass + ' h3-button' : 'h3-button';
    var slotContent = slots();
    var children = slotContent.default;

    if (children && children.length === 1) {
      var defaultNode = children[0];

      if (defaultNode && defaultNode.text) {
        var text = defaultNode.text.trim();

        if (text.length > 10) {
          defaultNode.text = text.substr(0, 10) + '...';
          data.attrs = data.attrs || {};
          data.attrs.title = text;
        }
      }
    }

    return createElement(_h3_antd_vue_lib_button__WEBPACK_IMPORTED_MODULE_1___default.a, _extends({
      props: props
    }, data), children);
  }
};

H3Button.install = function (Vue) {
  Vue.component(H3Button.name, H3Button);
};

/* harmony default export */ __webpack_exports__["default"] = (H3Button);

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

module.exports = require("@h3/antd-vue/lib/button/style");

/***/ })

/******/ });